"use strict";

var _interopRequireWildcard = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _auth = require("@/utils/auth");

var enumValue = _interopRequireWildcard(require("@/utils/enums"));

var _axios = _interopRequireDefault(require("axios"));

var validate = _interopRequireWildcard(require("@/utils/validate"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      device: {
        mobile: false
      },
      textarea: '',
      files: [],
      images: []
    };
  },
  computed: {
    suggestionById: function suggestionById() {
      return this.$store.getters.suggestionById;
    }
  },
  beforeMount: function () {
    var _beforeMount = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var suggestion, fileType;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              suggestion = this.$route.params.suggestion;

              if (!suggestion) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return (0, _auth.setIdEditPage)(suggestion.id);

            case 4:
              _context.next = 6;
              return this.$store.dispatch('suggestion/insertSuggestionUserRead', suggestion.id);

            case 6:
              _context.next = 8;
              return this.$store.dispatch('suggestion/getSuggestionById');

            case 8:
              fileType = enumValue.fileTypeEnum;

              if (this.suggestionById) {
                if (this.suggestionById.attach_files && this.suggestionById.attach_files.length) {
                  this.images = this.suggestionById.attach_files.filter(function (item) {
                    return item.attach_file_type === fileType.Image;
                  });
                  this.files = this.suggestionById.attach_files.filter(function (item) {
                    return item.attach_file_type === fileType.File;
                  });
                }
              }

              this.device.mobile = this.$device.mobile;
              this.textarea = this.replacePhoneEmailUrl(this.suggestionById.content);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  methods: {
    replacePhoneEmailUrl: function replacePhoneEmailUrl(text) {
      var data = text;
      var urls = data.split('\n');

      if (urls && urls.length) {
        data = this.buildReplace(data, urls);
      }

      var urlsSpace = data.split(' ');

      if (urlsSpace && urlsSpace.length) {
        data = this.buildReplace(data, urlsSpace);
      }

      return data.replace(validate.emailRegex, '<a target="_blank" href="mailto:$1">$1</a>').replace(validate.mobileRegex, 'Tel: <a target="_blank" href="tel:$1">$1</a>').replaceAll('\n', '</br>');
    },
    buildReplace: function buildReplace(data, list) {
      var _this = this;

      list.forEach(function (element) {
        var match = element.match(validate.urlRegex);

        if (match) {
          var result = match.toString();
          data = _this.urlReplaceFunction(data, result);
        }
      });
      return data;
    },
    urlReplaceFunction: function urlReplaceFunction(data, i) {
      var urlName = i.replace('https://', '').replace('www.', '');

      if (this.device.mobile && urlName.length) {
        if (urlName.length > 34) {
          urlName = urlName.substring(0, 34);
        }

        return data.replaceAll(i, "<a target=\"_blank\" href=\"".concat(i, "\">").concat(urlName, "</a>"));
      }

      return data.replaceAll(i, "<a target=\"_blank\" href=\"".concat(i, "\">").concat(urlName, "</a>"));
    },
    goToIndex: function goToIndex() {
      this.$router.replace({
        name: 'SuggestionIndex'
      });
    },
    downloadFile: function () {
      var _downloadFile = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(data) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                (0, _axios.default)({
                  url: data.url,
                  // File URL Goes Here
                  method: 'GET',
                  responseType: 'blob'
                }).then(function (res) {
                  var FILE = window.URL.createObjectURL(new Blob([res.data]));
                  var docUrl = document.createElement('a');
                  docUrl.href = FILE;
                  docUrl.setAttribute('download', data.file_name);
                  document.body.appendChild(docUrl);
                  docUrl.click();
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function downloadFile(_x) {
        return _downloadFile.apply(this, arguments);
      }

      return downloadFile;
    }()
  }
};
exports.default = _default;